/* Copyright © 2023 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and */
/* matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, */
/* including without limitation, material generated from the software programs which are displayed on the screen such */
/* as icons, screen display looks, etc. */

import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OptionListOptions } from '../services/workflow.service';

@Component({
  selector: 'xacc-connector-selector',
  templateUrl: './xacc-connector-selector.component.html',
  styleUrls: ['./xacc-connector-selector.component.less'],
  standalone: false,
})
export class XaccConnectorSelectorComponent {
  private _cloudRepos = [];
  @Input() set cloudRepos(value: []) {
    this._cloudRepos = value;
  }
  get cloudRepos(): OptionListOptions[] {
    return this._cloudRepos;
  }

  selectedConnector: OptionListOptions;
  repoGlyphs = {
    DocuShare: 'xgl-docushare_logo',
    GraphSharePoint: 'xgl-ms_office',
    GraphOneDrive: 'xgl-onedrive',
    GoogleDrive: 'xgl-google_drive',
    Dropbox: 'xgl-dropbox',
    Box: 'xgl-box_logo',
  };

  getRepoValue(value: string) {
    const repo = Object.keys(this.repoGlyphs).filter((key) => key === value)[0];
    return repo ? repo : null;
  }

  constructor(public activeModal: NgbActiveModal) {}
}
